<template>
  <!-- 树形组件带：增删改功能 -->
  <div class="cmp-tree">
    <div class="custom-tree-container">
      <div class="block">
        <el-tree ref="tree" draggable highlight-current :data="treeData" node-key="id" default-expand-all :allow-drop="allowDrop" :expand-on-click-node="false" @node-click="handleNodeClick" @node-drop="handleDrag">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <div :title="node.label">{{ node.label }}</div>
            <div class="menu" style="visibility:hidden">
              <!-- 菜单 -->
              <el-dropdown trigger="click" @command="handleOperate(node, data, $event)" @click.stop.native="nodeEditFocus">
                <span>
                  <svg-icon icon-class="more" class-name="icon-common g-pointer" style="font-size: 12px;color:#575962;" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">添加下级部门</el-dropdown-item>
                  <el-dropdown-item command="2">重命名</el-dropdown-item>
                  <el-dropdown-item command="3" v-if="node.level!==1">编辑部门信息</el-dropdown-item>
                  <el-dropdown-item command="4" v-if="node.level!==1">删除部门</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-tree>
      </div>
    </div>

    <dialogAddStaff ref="dialogAddStaff" :bussinessType="`department`" @refreshTree="refreshTree"></dialogAddStaff>
  </div>
</template>

<script>
import dialogAddStaff from '@views/staff//dialog-add-staff'
export default {
  components: { dialogAddStaff },
  props: {
    treeData: {
      type: Array,
      default() {
        return []
      }
    },
    // 高亮的id
    lightKey: {
      type: String,
      default: ''
    }
  },
  watch: {
    treeData(newVal) {
      console.log(newVal)
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(
          this.lightKey ? this.lightKey : newVal[0].id
        )
      })
    }
  },
  data() {
    return {
      // data: []
    }
  },
  methods: {
    init() {
      // this.getDataList()
    },
    // getDataList() {
    //   this.$http.get('/deptree/list').then(res => {
    //     if (res.success) {
    //       this.data = res.result
    //     } else {
    //       this.$message.error(res.message)
    //     }
    //   })
    // },
    // 点击菜单面板
    handleOperate(node, data, type) {
      switch (type) {
        // 添加
        case '1':
          this.append(node, data)
          break
        // 重命名
        case '2':
          this.append(node, data, '重命名')
          break
        // 编辑部门信息
        case '3':
          this.$refs.dialogAddStaff.init('edit', data.id)
          break
        // 删除部门
        case '4':
          // 预备删除部门
          this.$http
            .post('/deptree/predelete', {
              id: data.id
            })
            .then(res => {
              if (res.success) {
                if (res.result) {
                  // 允许删除
                  this.remove(node, data)
                } else {
                  // 不允许删除
                  this.$common.confirm(
                    {
                      title:
                        '该部门或子部门下存在人员，请先人员调离再操作删除！',
                      className: 'cus-confirm-375'
                    },
                    () => { }
                  )
                }
              } else {
                this.$message.error(res.message)
              }
            })
          break
      }
    },
    append(node, data, title) {
      this.$prompt('', title || '添加下级部门', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '请输入',
        // inputValue: null
        inputValue: title ? data.label : null,
        inputPattern: /^.{1,50}$/,
        inputErrorMessage: '请输入1到50位字符'
        // center: true
      })
        .then(({ value }) => {
          if (!title) {
            // 新增
            this.add(node, data, value)
          } else {
            // 编辑
            this.edit(node, data, value)
          }
        })
        .catch(() => { })
    },
    add(node, data, value) {
      this.$http
        .post('/deptree/add', {
          parentId: node.data.id,
          label: value
        })
        .then(res => {
          if (res.success) {
            if (!data.children) {
              this.$set(data, 'children', [])
            }
            const newChild = {
              id: res.result.id,
              label: value,
              children: []
            }
            data.children.push(newChild)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 编辑
    edit(node, data, value) {
      this.$http
        .post('/deptree/update', {
          id: node.data.id,
          label: value
        })
        .then(res => {
          if (res.success) {
            data.label = value
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 删除
    remove(node, data) {
      this.$common.confirm(
        {
          title: '您正在删除部门，若存在子部门将一同删除，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .post('/deptree/delete', {
              id: data.id
            })
            .then(res => {
              if (res.success) {
                const parent = node.parent
                const children = parent.data.children || parent.data
                const index = children.findIndex(d => d.id === data.id)
                children.splice(index, 1)

                this.$emit('resetEvent')
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 阻止事件冒泡
    nodeEditFocus() { },
    // 当前节点点击
    handleNodeClick(data, node) {
      this.$emit('getKey', { ...data }, { ...node })
    },
    // 移动：拖拽结束
    handleDrag(node, toNode, loc) {
      this.$http
        .post('/deptree/move', {
          id: node.data.id,
          targetId: toNode.data.id,
          parentId: toNode.parent.data.id,
          before: loc === 'before' ? true : false
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 同级之间可以拖拽
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === 'prev' || type === 'next'
        }
      } else {
        // 不同级进行处理
      }
    },
    refreshTree() {
      this.$emit('refresh')
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.cmp-tree {
  position: relative;
  // float: left;
  margin-right: 20px;
  min-width: 210px;

  /deep/ .el-tree {
    &.el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: transparent;
      color: $primary;
    }

    .el-tree-node__content {
      position: relative;
      padding-right: 30px;
      height: 40px;
      line-height: 40px;
      .custom-tree-node {
        font-size: 14px;
        .menu {
          position: absolute;
          right: 10px;
          top: 0;
        }
      }
      &:hover {
        background-color: $color3;
        .menu {
          // display: block;
          visibility: visible !important;
        }
      }
    }
  }
}
</style>


